module.exports = {
  "dof-rich-text": {
    "alignItems": "center",
    "flexDirection": "row"
  },
  "default-text": {
    "color": "#A5A5A5",
    "fontSize": "24",
    "lineHeight": "30"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7c699e5b!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-rich-text/index.vue
// module id = 516
// module chunks = 0 1